import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { VideoService } from '../../../../services/video.service';
import { Subscription } from 'rxjs/Subscription';
import { Video } from '../../../../models/video.model';
import { AdminService } from '../../../admin.service';
import { Menu } from '../../../../models/menu.model';

declare var jQuery: any;

@Component({
  selector: 'app-training-videos-dashboard',
  templateUrl: './training-videos-dashboard.component.html',
  styleUrls: ['./training-videos-dashboard.component.css']
})
export class TrainingVideosDashboardComponent implements OnInit {
  loading = true;
  menus: Menu[] = [];
  navigationType = 'link';
  navigationDefault = 'training-videos';
  subscription: Subscription;
  videos: Video[] = [];
  

  constructor(private videoService: VideoService, private adminService: AdminService) { }

  @ViewChild('previewModal') previewModal: ElementRef;


  ngOnInit() {
    this.menus = [
      new Menu('Training', '', [
        new Menu('Training Videos', 'help/training-videos'),
      ]),
      new Menu('Frequently asked questions', '', [
        new Menu('FAQ', 'help/faqs'),
        new Menu('FAQ Categories', 'help/faqscategory'),
      ]),
      new Menu('Changelogs', '', [
        new Menu('Changelogs', 'help/changelogs')
      ])
    ];

    this.adminService.loadMenu(this.menus);

    this.adminService.routeData.next({
      'route': null,
      default: this.navigationDefault,
      type: this.navigationType
    });
    
    this.videoService.httpGetVideos();
    
    this.subscription = this.videoService.videosChanged.subscribe(
      (videos: Video[]) => {
        this.videos = videos;

        setTimeout(
          () => {
            this.loading = false;
            jQuery('table').DataTable({
              'oLanguage': { 'sSearch': '', 'sLengthMenu': '_MENU_' },
              'pageLength': 50,
              'retrieve': true,
              'order': []
            });
    
            jQuery('input[type=search]').addClass('btn-search');
            jQuery('input[type=search]').attr('placeholder','Search');
            jQuery('select').addClass('select_datatable');
            jQuery('select').append('<option selected>Filter</option>');
          }, 1000
        );
        
      }
    );

  }

  onPreview(link: string) {
    this.previewModal.nativeElement.querySelector('.modal-body iframe').src
      = link;
  }

  onDelete(id: number) {
    this.videoService.httpDeleteVideo(id);
  }

  cutString(title: string){
    return title.slice(0, 100);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/help/training-videos/training-videos-dashboard/training-videos-dashboard.component.ts